import axios from "axios";

export default {
    updatePublic(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "public/patient",
        });
    },
    getAllExcel(data) {
        return axios({
            method: "post",
            data: data,
            responseType: "blob",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patients/contacts/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllExcelGalatea(data) {
        return axios({
            method: "post",
            data: data,
            responseType: "blob",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patients/contacts/galatea/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createPublic(professionalId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "public/professional/" +
                professionalId +
                "/patient",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createGalatea(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/galatea",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    update(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/" + data.id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllTransactionsWallet(currentPage = 0, pageSize = 10, patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                patientId +
                "/wallet/transactions?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateTransactionsWallet(idPatient, idWalletTransaction, data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/" + idPatient + "/wallet/transaction/" + idWalletTransaction,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllActive() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patients/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll(filter) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patients?filter=" + filter,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllContacts(currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patients/contacts?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findHistoricsStore(idPatient, idHistoricStore) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                idPatient +
                "/historic/store/" +
                idHistoricStore,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllHistoricsStore(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                id +
                "/historics/store",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    sendInvitation(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/send/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    changeStatus(id, status) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/patient/" + id + "/" + status,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    changeHide(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/patient/" + id + "/action/hide",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getMoreInformation(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/more/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getGalateaInformation(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/galatea/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateGalatea(data, patientId) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/galatea/" + patientId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateMore(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/more/" + data.id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getSettings(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/patient/settings/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateSettings(data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/patient/settings/" + data.id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllRecipes(currentPage = 0, pageSize = 10, id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                id +
                "/recipes?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllPetitioners(currentPage = 0, pageSize = 10, id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                id +
                "/petitioners?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    //Pay event
    payStripe(patientId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                patientId +
                "/pay/stripe",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payPaypal(patientId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                patientId +
                "/pay/paypal",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCash(patientId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                patientId +
                "/pay/cash",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    paySuccess(patientId, id, option, tokenback, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                patientId +
                "/pay/success/" +
                option +
                "/" +
                tokenback +
                "/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    payCancel(patientId, id, option, tokenback, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/patient/" +
                patientId +
                "/pay/cancel/" +
                option +
                "/" +
                tokenback +
                "/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
